import Vue from "vue"
import Vuex from "vuex"

import itemModal from "./modules/itemModal"

Vue.use(Vuex)
import { getCart } from "@/services/cart"
import { getters } from "./getters"

export default new Vuex.Store({
  state: {
    cart: {},
    sanitizedCartItems: [],
    cartUpdating: false,
    customerID: null,
    persons: null,
    options: [],
    updateCart: false,
    language: "en",
    cartLastUpdated: null,
  },
  mutations: {
    async setCart(state, { cart }) {
      state.cart = cart
      for (const cartItem in cart.groupedCartItems) {
        state.options = state.options.concat(
          cart.groupedCartItems[cartItem].options
        )
      }
    },
    setLanguage(state, locale) {
      state.language = locale
    },
    setCartLastUpdated(state) {
      state.cartLastUpdated = new Date()
    },
    setCartUpdateStatus(state, { status }) {
      state.cartUpdating = status
    },
    setPersons(state, { persons }) {
      state.persons = persons
    },
    setCustomerID(state, { customerID }) {
      if (customerID === "") {
        state.customerID = null
      } else {
        state.customerID = customerID
      }
    },
  },
  actions: {
    async updateCart({ commit }) {
      commit("setCartUpdateStatus", { status: true })

      const cart = await getCart()
      commit("setCart", { cart: cart })

      commit("setCartUpdateStatus", { status: false })
    },
    updateCartItem({ commit, state }, { cartItem }) {
      const cart = state.cart
      const itemID = cartItem.itemID
      const cartItemID = cartItem.cartItemID

      const cartItemIndex = cart.groupedCartItems[itemID].cartItems.findIndex(
        (cartItem) => cartItem.cartItemID === cartItemID
      )

      cart.groupedCartItems[itemID].cartItems[cartItemIndex] = cartItem

      commit("setCart", { cart })
    },
    deleteCartItem({ commit, state }, { cartItemID, itemID }) {
      const cart = state.cart
      cart.groupedCartItems[itemID].cartItems = cart.groupedCartItems[
        itemID
      ].cartItems.filter((cartItem) => cartItem.cartItemID !== cartItemID)
      commit("setCart", { cart })
    },
    removeCartItem({ state }, { cartItemID }) {
      state.cart.cartItems = state.cart.cartItems.filter(
        (cartItem) => cartItem.cartItemID !== cartItemID
      )
    },
  },
  modules: {
    itemModal,
  },
  getters,
})
